import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TournamentsListEmpty, TournamentsListView } from '@/components/TournamentsListView';
import { useTournamentsListContext } from '@/layouts/TournamentsListLayout/context';

const PublicTournamentsTab: React.FC = () => {
  const { t } = useTranslation(['tournament']);
  const { activeTab } = useTournamentsListContext();

  return (
    <TournamentsListView
      source="public"
      isActive={activeTab === 'public'}
      title={t('tournament:publicTournaments')}
      emptyState={(
        <TournamentsListEmpty
          title={t('tournament:noTournamentsFound')}
          text={t('tournament:noPublicTournamentsAvailable')}
          actions={(
            <Link to="/tournaments" className="ls-btn">
              {t('tournament:myTournaments')}
            </Link>
          )}
        />
      )}
    />
  );
};

export default PublicTournamentsTab;
